import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ReactComponent as SuccessIcon } from 'src/assets/svg/success-green-circle.svg';
import { selectUserLoggedIn, selectUserName } from 'src/store/slices/user-slice';

import { styles } from './styles';

export const LoggedInBanner: FC = () => {
    const { t } = useTranslation();
    const loggedIn = useSelector(selectUserLoggedIn);
    const userName = useSelector(selectUserName);
    if (!loggedIn) {
        return null;
    }

    return (
        <Box css={styles.container}>
            <Box css={styles.infoWrapper}>
                <SuccessIcon />
                <Box css={styles.info}>
                    <Typography variant="h2">
                        {t('your_details_logged_in_title', {
                            name: userName,
                        })}
                    </Typography>
                    <Typography variant="body3">{t('your_details_logged_in_subtitle')}</Typography>
                </Box>
            </Box>
        </Box>
    );
};
